export default __webpack_public_path__ + "static/media/bannerBg.2e59702a.png";